import { render, staticRenderFns } from "./CountUp.vue?vue&type=template&id=61f57fb0&scoped=true&"
import script from "./CountUp.vue?vue&type=script&lang=js&"
export * from "./CountUp.vue?vue&type=script&lang=js&"
import style0 from "./CountUp.vue?vue&type=style&index=0&id=61f57fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f57fb0",
  null
  
)

export default component.exports